"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AccordionControlled from "./AccordionControlled.js";
const AccordionUncontrolled = (props) => {
    const { defaultActive, onToggle, ...controlledProps } = props;
    const [active, setActive] = React.useState(defaultActive || false);
    const handleToggle = (active) => {
        setActive(active);
        onToggle?.(active);
    };
    return _jsx(AccordionControlled, { ...controlledProps, onToggle: handleToggle, active: active });
};
AccordionUncontrolled.displayName = "AccordionUncontrolled";
export default AccordionUncontrolled;
